import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { GoToHomeLoader } from '@confluence/home-redirects/entry-points/GoToHome';
import { SiteHomepageRedirectLoader } from '@confluence/home-redirects/entry-points/SiteHomepageRedirect';

export const WikiRoute = () => (
	<SiteHomepageRedirectLoader>
		<GoToHomeLoader />
	</SiteHomepageRedirectLoader>
);

WikiRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'wikiScreen' },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
	},
});
